// ============================================================================
// view.newsletterAdmin — migrated off the global read
// ============================================================================
// The admin newsletter workspace renders three mutually-exclusive component
// modes (list | editor | settings) from local state, not URL splits. Each gets
// a resource matching only the render reads it actually issues.
//
// All resources are RPC-shaped: newsletter_* tables are deny-all RLS to the
// browser. The AI availability probe and photo thumbnail URL calls remain local;
// they are Edge/storage calls with no resource declaration vocabulary.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.newsletterAdmin',
  obligations: Object.freeze([
    Object.freeze({id: 'newsletter.issues.core', owner: 'permanent'}),
    Object.freeze({id: 'newsletter.settings.core', owner: 'permanent'}),
    Object.freeze({id: 'newsletter.issue.detail', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
